export default __webpack_public_path__ + "static/media/Screenshot from 2020-08-03 23-02-02.db5b1924.png";